const ch = {
  subMenu: {
    managementScreenUserRegistration: '管理畫面使用者登錄',
    accountManagement: '帳戶管理',
    userManagement: '使用者管理',
    order: 'order',
    itemInformation: '商品情報',
    itemImageUpload: '上傳商品圖片',
    searchConfig: '搜尋設定',
    category: '分類',
    menu: 'MENU',
    price: '價格',
    ad: '廣告',
    recommendOnOrder: '點餐時推薦',
    timedRecommend: '限時式推薦',
    eventInformation: '活動情報',
    eventList: '活動一覽',
    operationalManagement: '運用管理',
    allShopsConfig: '全店套用同一設定',
    shopList: '店鋪一覽',
    groupConfig: '設定群組',
    'sumahoDeBikkurapon-jp': '副餐扭蛋',
    sumahoDeBikkurapon: '副餐扭蛋',
    sumahoDeBikkuraponConfig: '副餐扭蛋設定',
  },
  common: {
    language: '語',
    create: '新增登錄',
    csvUpload: 'CSV上傳',
    csvDownload: 'CSV下載',
    displayCount: '表示件數',
    search: '搜尋',
    itemCode: '商品CODE',
    itemName: '商品名',
    itemNameJapanese: '商品名/日文',
    itemNameEnglish: '商品名/英文',
    itemNameTraditionalChinese: '商品名/中文(繁體字)',
    itemNameSimplifiedChinese: '商品名/中文(簡體字)',
    itemNameKorean: '商品名/韓文',
    calorie: '热量',
    calorieUnit: 'kcal',
    manufacturingCategory: '製造區分',
    topping: '配料',
    image: '圖片',
    normalImage: '一般圖片',
    wideImage: '橫的圖片',
    normal: '一般',
    wide: '橫的',
    edit: '編輯',
    totalCount: '總件數',
    itemUnit: '件',
    back: '返回',
    inputComplete: '輸入完畢',
    csvFile: 'CSV檔案',
    import: '參考',
    upload: '上傳',
    imageUpload: '上傳圖片',
    csvFileUploadDescription: '只能上傳小於5MB的csv檔案',
    fileName: '檔案名稱',
    status: '狀況',
    uploadDate: '上傳日',
    importStartTime: '導入開始日期',
    importEndTime: '導入結束日期',
    delete: '刪除',
    categoryId: '分類ID',
    categoryName: '分類名',
    categoryNameJapanese: '分類名/日文',
    categoryNameEnglish: '分類名/英文',
    categoryNameTraditionalChinese: '分類名/中文(繁體字)',
    categoryNameSimplifiedChinese: '分類名/中文(簡體字)',
    categoryNameKorean: '分類名/韓文',
    save: '保存',
    implementationGroup: '實施群組',
    implementationTiming: '實施時機點',
    menuOnOrder: '點餐時菜單',
    recommend: '推薦',
    recommendMenu: '推薦菜單',
    startTime: '開始日期',
    endTime: '結束日期',
    eventName: '活動名稱',
    conditionBranch: '條件分支',
    behavior: '動作',
    shopName: '店鋪名',
    shopId: '店鋪ID',
    select: '選擇',
    unselected: '未選擇',
    operation: '運用',
    stop: '停止',
    setting: '設定',
    cancel: '取消',
    add: '追加',
    display: '表示',
    hidden: '隱',
    yen: '日元',
    twGen: '元',
    cnGen: '元',
    dollar: '{price}美元',
    isSuccess: '成功',
    isFailure: '失敗',
    hasRegistered: '已登錄',
    hasNotRegistered: '登錄失敗',
    hasUpdated: '更新成功',
    hasNotUpdated: '更新失敗',
    backToHome: '返回主畫面',
  },
  commonCsvUpload: {
    processWaiting: '等待處理',
    processing: '處理中',
    imported: '收集完成',
    error: '錯誤',
  },
  loginPage: {
    loginPageName: '手機點餐管理登入畫面',
    login: '登入',
    orderWithTheSmartphone: '手機點餐',
  },
  accountManagementPage: {
    userList: '使用者一覽',
    userName: '使用者名',
    userId: '使用者ID',
    userRegistration: '使用者登錄',
    emailAddress: '郵件地址',
    password: '密碼',
    passwordConfirmation: '密碼(確認)',
    name: '名字',
    authority: '權限',
    authorityList: '權限一覽',
    screen: '畫面',
    all: '全部',
    ShopWholeConfig: '店鋪',
    editUser: '使用者編輯',
    deletionConfirmation: '可以刪除嗎',
    deleteUser: '刪除使用者',
  },
  orderPage: {
    lineup: '商品一覽',
    itemCsvUpload: '商品CSV上傳',
    calorieCsvUpload: '热量CSV上傳',
    itemCsvDownload: '商品CSV下載',
    calorieCsvDownload: '热量CSV下載',
    registrationConfirmation: '即將登錄.確定執行嗎?',
    imageDeletionConfirmationBefore: '即將刪除',
    imageDeletionConfirmationAfter: '圖片,確定要執行嗎?',
    priceChange: '調整價格',
    applicable: '適用',
    notApplicable: '不適用',
    itemInformationRegistration: '登錄商品情報',
    japanese: '日文',
    english: '英文',
    traditionalChinese: '中文(繁體字)',
    simplifiedChinese: '中文(簡體字)',
    korean: '韓文',
    productionLanguage1: '商品名稱_語言1',
    productionLanguage2: '商品名稱_語言2',
    productionLanguage3: '商品名稱_語言3',
    productionLanguage4: '商品名稱_語言4',
    productionLanguage5: '商品名稱_語言5',
    productionLanguage6: '商品名稱_語言6',
    productionLanguage7: '商品名稱_語言7',
    productionLanguage8: '商品名稱_語言8',
    productionLanguage9: '商品名稱_語言9',
    productionLanguage10: '商品名稱_語言10',
    itemCode: '商品CODE',
    itemName: '商品名',
    displayMenu: '顯示MENU',
    displayWide: '橫向顯示',
    unitType: '提供單位',
    provideUnitId: '提供單位ID',
    toppingType: '配料種類',
    typesOfGarnishments: '配料種類',
    manufacturingDivisionId: '製造區分ID',
    tagTextString: 'tag文字列',
    plate: '盤',
    piece_hon: '瓶',
    piece_ko: '個',
    cup: '杯',
    itemInformationUpload: '上傳商品情報',
    itemInformationCsv: '商品情報CSV',
    editItemInformation: '修正商品情報',
    searchTagInformationUpload: '上傳搜尋tag情報',
    searchTagInformationCsv: '搜尋tag情報CSV',
    deleteSearchTag: '刪除搜尋tag情報',
    itemImageUploadAttention:
      '※請注意,按下圖片後會立即上傳,菜單圖片將被立即更新',
    dragAndDropHere: '請將檔案拖曳移動至此',
    orSelectFile: '或選擇檔案',
    fileOverwriteAttention: '※同一個檔案名稱即將被覆蓋,請注意',
    uploadImageList: '上傳圖片清單',
    successfulUploadItemImage: '商品圖像上傳成功',
    pendingUploadItemImage: '準備上傳',
    processingUploadItemImage: '正在上傳...',
    invalidUploadItemImage: '不支持這種類型的文件',
    failureUploadItemImage: '商品圖像上傳失敗',
    uploadAlert: '正在處理圖像。你想搬家嗎？',
    deleteItemImage: '刪除圖像',
    searchSettings: '搜尋設定',
    item: '商品',
    tag: 'tag',
    searchTag: '搜尋tag',
    addTag: '追加tag',
    addSearchTag: '追加搜尋tag情報',
    addShop: '追加店鋪',
    tagId: 'tag ID',
    searchTagName: '搜尋tag名',
    searchTagInformation: '搜尋tag情報',
    addItem: '追加商品',
    categoryList: '分類一覽',
    categoryInformationRegistration: '登錄分類情報',
    inputConfirmation: '確認輸入',
    registration: '登錄',
    editCategoryInformation: '編輯分類情報',
    categoryDeletionConfirmationBefore: '是否刪除',
    categoryDeletionConfirmationAfter: '的分類嗎',
    deleteCategoryBefore: '刪除',
    deleteCategoryAfter: '的分類',
    changeCategoryDisplayOrder: '變更分類的順序',
    createNewMenu: '新增',
    copyPublishedMenuNotice: '請以現在公開中的MENU為基礎,製作新MENU',
    noOpenMenu: '沒有公開中的MENU',
    createOpenMenu: '請製作公開中的MENU',
    editDraft: '編輯草稿',
    editDraftNotice: '修正現在製作中的MENU',
    editPublishedMenu: '編輯公開中的MENU',
    editPublishedMenuNotice: '修正現在公開中的MENU',
    menuDraft: 'MENU草稿',
    menuConfig: '設定MENU',
    editingTheMenuInOperation: '正在編輯運用中的MENU',
    useStartTime: '利用開始日期',
    useEndTime: '利用結束日期',
    menuStatus: 'MENU狀態',
    draft: '草稿',
    inOperation: '運用中',
    inOperationMenu: '運用中的MENU',
    preview: '預覽',
    menuDisplay: '顯示MENU',
    wideDisplay: '橫向顯示',
    editingDraft: '正在編輯草稿',
    tableNo: '號桌',
    call: '呼叫',
    check: '結帳',
    priceInformation: '價格情報',
    priceInformationList: '價格情報一覽',
    pricePatternId: '價格格式ID',
    pricePatternIdCsv: '價格格式ID',
    pricePatternName: '價格格式名',
    pricePatternNameCsv: '價格格式名',
    priceId: '價格ID',
    priceName: '名稱',
    updateCategory: '更新區分',
    priceInformationUpload: '上傳價格情報',
    priceInformationCsv: '價格情報CSV',
    itemCalorie: '热量情報',
    itemCalorieUpload: '上傳热量情報',
    itemCalorieCsv: '热量情報CSV',
  },
  adPage: {
    recommendOnOrderList: '點餐時推薦一覽',
    recommendOnOrderRegistration: '登錄點餐時推薦',
    orderMenu: '點餐MENU',
    editRecommendOnOrder: '編輯點餐時推薦',
    recommendUpload: '上傳推薦',
    recommendCsv: '推薦CSV',
    recommendOnOrderDeletionConfirmation: '是否刪除點餐時推薦情報?',
    timedRecommendDeletionConfirmation: '是否刪除限時式推薦情報?',
    deleteRecommendOnOrder: '刪除點餐時推薦情報',
    deleteTimedRecommend: '刪除限時式推薦情報',
    timedRecommendList: '限時式推薦一覽',
    timedRecommendRegistration: '限時式推薦登錄',
    implementationTimingConditions: '時間點實施條件',
    elapsedTime: '經過時間',
    minutesLater: '分後',
    timedRecommendImage: '限時式推薦圖片',
    imageUploadDescription: '只能上傳小於1MB的png或jpg檔案',
    recommendPeriod: '推薦期間',
    recommendPeriodStart: '推薦期間(開始日)',
    recommendPeriodEnd: '推薦期間(結束日)',
    fromTheFirstOrder: '從最初的點餐',
    fromTheLastOrder: '從最後的點餐',
    immediatelyAfterAuthentication: '認證之後',
    editTimedRecommend: '編輯限時式推薦',
    itemIsYetNotRegistered: '商品尚未登錄',
  },
  eventInformationPage: {
    deleteEventInformation: '刪除活動情報',
    eventRegistration: '登錄活動',
    editEvent: '活動編輯',
    postingTerm: '播放期間',
    postingTermStart: '播放期間(開始日)',
    postingTermEnd: '播放期間(結束日)',
    startDate: '開始日',
    yearsMonthDate: '年/月/日',
    endDate: '結束日',
    decisionTiming: '判定時機點',
    whenSeatAuthentication: '座位認證時',
    whenOrder: '點餐時',
    eventConditions: '活動條件',
    birthMonth: '出生月份',
    visitInBirthMonth: '出生月份時來店',
    operationAtConditionCoincidence: '條件一致時的動作',
    gachadamaEmission: '扭蛋排出',
    bikkuraponLottery: '扭蛋抽選',
    optionalVideo: '任意影片',
    videoName: '影片名',
    shopGroupList: '店鋪群組一覽',
    groupId: '群組ID',
    groupName: '群組名',
    userAttribute: '使用者屬性',
    emission: '排出',
    lottery: '抽選',
    video: '影片',
    eventInformationDeletionConfirmation: '確定刪除活動情報嗎?',
  },
  operationalManagementPage: {
    soOrderLimitCountAttention: '若輸入SO注文限制件數,其他的店鋪也一起更改',
    orderLimit: 'SO注文限制件數',
    orderLimitShop: 'SO注文限制件數(店鋪)',
    orderLimitTable: 'SO注文限制件數(桌)',
    orderLimitPreOrder: 'SO注文限制件數(提前點餐)',
    itemMinMax: '件數(0~99)',
    table: '桌',
    preOrder: '提前點餐',
    soOperationAttention:
      '「運用」基本上只在需要將全部店鋪的SO運用暫時停止（或再開）的特殊情況使用。\nSO運用設定為「運用」時,會以店鋪各自設定的SO運用優先套用',
    soOperation: 'SO運用',
    bikkuraponRateChange: '調整扭蛋機率',
    priceDisplay: '價格顯示',
    bikkuraponIconDisplay: '扭蛋圖標顯示',
    kuraCode: 'くら寿司店鋪CODE',
    shopName: '店鋪名',
    eparkGourmetId: 'EPARK內用ID',
    eparkTakeoutId: 'EPARK外帶ID',
    tableCount: '店鋪桌號碼數',
    lastOrder: '最後點餐',
    shopLimitNumber: '店鋪限制數',
    soOperationalStatus: 'SO運用狀況',
    selfCheckOperationalStatus: '自助結帳運用狀況',
    shopConfig: '店鋪設定',
    qrForSeat: '座位用QR CODE',
    qrCodeDisplayForSeatAuthorization: '顯示座位認證用QR CODE',
    wholeSelection: '全選',
    wholeDeselection: '取消全選',
    printSelectedQr: '列印已選擇的QR CODE',
    soWebSupportedVersion: 'SOWeb應對版(新版)',
    appVersion: 'APP版(舊版)',
    shopNumber: '店鋪號碼',
    seatNumber: '桌席號碼',
    changeQr: '變更QR CODE',
    qrCodeIsUnselected: '未選擇QR CODE',
    qrCodeUnset: '的QR CODE還沒設定',
    ofQrCode: '的QR CODE',
    qrCodeChange: '變更QR CODE',
    qrCodePrinting: '列印QR CODE',
    shopInformation: '店鋪情報',
    shopInformationRegistration: '登錄店鋪情報',
    editShopInformation: '編輯店鋪情報',
    priceBand: '價格範圍',
    numberOfSeats: '桌號數',
    gourmetShopId: '內用店鋪ID',
    takeOutShopId: '外帶店鋪ID',
    soOrderLimit: 'SO點餐限制',
    soOrderLimitAllSeats: 'SO點餐限制(店舗全体)',
    soOrderLimitTable: 'SO點餐限制(桌)',
    soOrderLimitPreOrder: 'SO點餐限制(提前點餐)',
    allSeats: '店鋪全體',
    selfcheckOperation: '自助結帳運用',
    shopInformationUpload: '上傳店鋪情報',
    shop: '店鋪',
    group: '群組',
    addGroup: '追加群組',
    shopGroupInformationUpload: '上傳店鋪情報',
    shopGroupInformation: '店鋪情報',
    addShopGroup: '追加群組',
    deleteShopGroup: '刪除群組',
    update: '更新',
    globalSettings: '全體設定',
    stopping: '停止中',
    emissionSetting: '排出設定',
    numberOfTimes: '次數',
    probability: '機率',
    individualSetting: '個別設定',
    bikkuraponInstallation: '扭蛋設置',
    amountOfMoney: '金額',
    rotation: '次數(次)',
    probabilityPercent: '機率(%)',
    notInstalled: '未設置',
    off: '無',
    on: '有',
  },
}

export default ch
